// API configuration
export const API_BASE_URL = 'http://localhost:8080';

// API endpoints
export const API_ENDPOINTS = {
    SEARCH: `${API_BASE_URL}/api/search`,
    ANALYZE_WEBSITE: `${API_BASE_URL}/api/analyze-website`,
    USERS: `${API_BASE_URL}/api/users`,
} as const; 